<template>
  <div class="card">
    <div v-if="!showIndividualStats" class="card-body">
      <ul id="myTab" class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a
              id="active-tab"
              aria-controls="up"
              class="nav-link active show"
              data-toggle="tab"
              href="#currentWeek"
              role="tab"
              @click="selectedTab = 'currentWeek'"
          >This Week</a
          >
        </li>
      </ul>
      <div class="tab-content customer-table">
        <div v-if="selectedTab === 'currentWeek'" id="currentWeek" class="tab-pane active show mt-15">
          <div class="row mb-20 d-flex align-items-center">
            <div class="col-md-2">
              <label for="">Select Date</label>
              <input :min="'2025-01-01'" class="form-control" type="date" @input="onSelectDate">
            </div>
            <div class="col-md-2 pl-0">
              <button class="btn btn-sm btn-default mt-30" @click="resetFilter">Reset</button>
            </div>
            <div class="col-md-4 d-flex align-items-center justify-content-center fw-600 mt-30">
              <span>({{ parseDate(weekDates[0]) }} - {{ parseDate(weekDates[6]) }})</span>
            </div>
            <div v-if="secretEmails.includes(user.email)"
                 class="col-md-4 d-flex align-items-center justify-content-end fw-600 mt-30">
              <button class="btn btn-default btn-sm" @click="openStaffTicketStats">Staff Stats</button>
            </div>
          </div>

          <table class="table">
            <thead>
            <tr>
              <th class="text-center make-cursor-pointer"
                  @click="changeWeekDates(currentDate === originalCurrentDate ? 'prev' : 'current')">
                <span v-if="weekDatesWithDays.length && !filterEnabled">
                  <i v-if="currentDate === originalCurrentDate" class="fa fa-arrow-left fs-24"></i>
                  <i v-else class="fa fa-arrow-right fs-24"></i>
                </span>
              </th>
              <th v-for="(row, index) in weekDatesWithDays" :key="index" :class="getHighlightClass(row)"
                  class="text-center">{{ row.day }} <br> ({{ row.date }}) <br>
                <span v-if="!getAvg(row).predicted" class="text-info d-flex align-items-center justify-content-center">This Week: {{
                    getAvg(row).avg
                  }}
                <span v-if="row.date === originalCurrentDate"
                      class="badge badge-success badge-pill ml-4 pt-3 pb-2 pr-5 pl-5 mt-4">
                  Live
                </span>
                <br></span> <span class="text-danger">Prev:</span> {{ getAvg(row).prevWeekAvg }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in makeTicketStats" :key="index">
              <td class="text-center text-danger fw-600">{{ row.time }}</td>
              <td :style="getClass(row.mon, row.time, 'Monday')"
                  :width="row.mon && row.mon.date === originalCurrentDate ? '18%' : ''" class="text-center fw-600"
                  style="position: relative" @click="openStaffDetails(row.mon, row.time)">
                <div
                    v-if="currentTime.split(':')[0] === row.time.split(':')[0] && row.mon && row.mon.date === originalCurrentDate"
                    :id="`mon_${index}`"
                    class="d-flex align-items-center justify-content-center make-cursor-pointer"
                    @mouseleave="getTitle({...row.mon, index, day: 'mon', time: row.time}, false)"
                    @mouseover="getTitle({...row.mon, index, day: 'mon', time: row.time, live: true}, true)">
                  <span class="mr-10">{{
                      calculateBusyCoefficient({
                        ...row.mon.last15Min,
                        time: row.time
                      }, row.mon.date)
                    }}</span>
                  <span class="badge badge-success badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                    Live
                  </span>
                  <span>&nbsp | {{ getLastWeekStats(row.mon, row.time) }}
                    <span class="badge badge-danger badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                      Prev Week
                    </span>
                  </span>
                </div>
                <span v-else :id="`mon_${index}`" class="make-cursor-pointer"
                      @mouseleave="getTitle({...row.mon, index, day: 'mon', time: row.time}, false)"
                      @mouseover="getTitle({...row.mon, index, day: 'mon', time: row.time}, true)">{{
                    row.mon && row.mon.hoursArray ? getVal(row.mon.hoursArray, row.time, row.mon.date) : 0
                  }}</span>
              </td>
              <td :style="getClass(row.tues, row.time,'Tuesday')"
                  :width="row.tues && row.tues.date === originalCurrentDate ? '18%' : ''" class="text-center fw-600"
                  style="position: relative" @click="openStaffDetails(row.tues, row.time)">
                <div
                    v-if="currentTime.split(':')[0] === row.time.split(':')[0] && row.tues && row.tues.date === originalCurrentDate"
                    :id="`tues_${index}`"
                    class="d-flex align-items-center justify-content-center make-cursor-pointer"
                    @mouseleave="getTitle({...row.tues, index, day: 'tues', time: row.time}, false)"
                    @mouseover="getTitle({...row.tues, index, day: 'tues', time: row.time, live: true}, true)">
                  <span class="mr-10">{{ calculateBusyCoefficient({...row.tues.last15Min, time: row.time}) }}</span>
                  <span class="badge badge-success badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                    Live
                  </span>
                  <span>&nbsp | {{ getLastWeekStats(row.tues, row.time) }}
                    <span class="badge badge-danger badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                      Prev Week
                    </span>
                  </span>
                </div>
                <span v-else :id="`tues_${index}`" class="make-cursor-pointer"
                      @mouseleave="getTitle({...row.tues, index, day: 'tues', time: row.time}, false)"
                      @mouseover="getTitle({...row.tues, index, day: 'tues', time: row.time}, true)">{{
                    row.tues && row.tues.hoursArray ? getVal(row.tues.hoursArray, row.time, row.tues.date) : 0
                  }}</span>
              </td>
              <td :style="getClass(row.wed, row.time, 'Wednesday')"
                  :width="row.wed && row.wed.date === originalCurrentDate ? '18%' : ''" class="text-center fw-600"
                  style="position: relative" @click="openStaffDetails(row.wed, row.time)">
                <div
                    v-if="currentTime.split(':')[0] === row.time.split(':')[0] && row.wed && row.wed.date === originalCurrentDate"
                    :id="`wed_${index}`"
                    class="d-flex align-items-center justify-content-center make-cursor-pointer"
                    @mouseleave="getTitle({...row.wed, index, day: 'wed', time: row.time}, false)"
                    @mouseover="getTitle({...row.wed, index, day: 'wed', time: row.time, live: true}, true)">
                  <span class="mr-10">{{ calculateBusyCoefficient({...row.wed.last15Min, time: row.time}) }}</span>
                  <span class="badge badge-success badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                    Live
                  </span>
                  <span>&nbsp | {{ getLastWeekStats(row.wed, row.time) }}
                    <span class="badge badge-danger badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                      Prev Week
                    </span>
                  </span>
                </div>
                <span v-else :id="`wed_${index}`" class="make-cursor-pointer"
                      @mouseleave="getTitle({...row.wed, index, day: 'wed', time: row.time}, false)"
                      @mouseover="getTitle({...row.wed, index, day: 'wed', time: row.time}, true)">{{
                    row.wed && row.wed.hoursArray ? getVal(row.wed.hoursArray, row.time, row.wed.date) : 0
                  }}</span>
              </td>
              <td :style="getClass(row.thurs, row.time, 'Thursday')"
                  :width="row.thurs && row.thurs.date === originalCurrentDate ? '18%' : ''" class="text-center fw-600"
                  style="position: relative" @click="openStaffDetails(row.thurs, row.time)">
                <div
                    v-if="currentTime.split(':')[0] === row.time.split(':')[0] && row.thurs && row.thurs.date === originalCurrentDate"
                    :id="`thurs_${index}`"
                    class="d-flex align-items-center justify-content-center make-cursor-pointer"
                    @mouseleave="getTitle({...row.thurs, index, day: 'thurs', time: row.time}, false)"
                    @mouseover="getTitle({...row.thurs, index, day: 'thurs', time: row.time, live: true}, true)">
                  <span class="mr-10">{{ calculateBusyCoefficient({...row.thurs.last15Min, time: row.time}) }}</span>
                  <span class="badge badge-success badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                    Live
                  </span>
                  <span>&nbsp | {{ getLastWeekStats(row.thurs, row.time) }}
                  <span class="badge badge-danger badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                      Prev Week
                    </span>
                  </span>
                </div>
                <span v-else :id="`thurs_${index}`" class="make-cursor-pointer"
                      @mouseleave="getTitle({...row.thurs, index, day: 'thurs', time: row.time}, false)"
                      @mouseover="getTitle({...row.thurs, index, day: 'thurs', time: row.time}, true)">{{
                    row.thurs && row.thurs.hoursArray ? getVal(row.thurs.hoursArray, row.time, row.thurs.date) : 0
                  }}</span>
              </td>
              <td :style="getClass(row.fri, row.time, 'Friday')"
                  :width="row.fri && row.fri.date === originalCurrentDate ? '18%' : ''" class="text-center fw-600"
                  style="position: relative" @click="openStaffDetails(row.fri, row.time)">
                <div
                    v-if="currentTime.split(':')[0] === row.time.split(':')[0] && row.fri && row.fri.date === originalCurrentDate"
                    :id="`fri_${index}`"
                    class="d-flex align-items-center justify-content-center make-cursor-pointer"
                    @mouseleave="getTitle({...row.fri, index, day: 'fri', time: row.time}, false)"
                    @mouseover="getTitle({...row.fri, index, day: 'fri', time: row.time, live: true}, true)">
                  <span class="mr-10">{{ calculateBusyCoefficient({...row.fri.last15Min, time: row.time}) }}</span>
                  <span class="badge badge-success badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                    Live
                  </span>
                  <span>&nbsp | {{ getLastWeekStats(row.fri, row.time) }}
                    <span class="badge badge-danger badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                      Prev Week
                    </span>
                  </span>
                </div>
                <span v-else :id="`fri_${index}`" class="make-cursor-pointer"
                      @mouseleave="getTitle({...row.fri, index, day: 'fri', time: row.time}, false)"
                      @mouseover="getTitle({...row.fri, index, day: 'fri', time: row.time}, true)">{{
                    row.fri && row.fri.hoursArray ? getVal(row.fri.hoursArray, row.time, row.fri.date) : 0
                  }}</span>
              </td>
              <td :style="getClass(row.sat, row.time, 'Saturday')"
                  :width="row.sat && row.sat.date === originalCurrentDate ? '18%' : ''" class="text-center fw-600"
                  style="position: relative" @click="openStaffDetails(row.sat, row.time)">
                <div
                    v-if="currentTime.split(':')[0] === row.time.split(':')[0] && row.sat && row.sat.date === originalCurrentDate"
                    :id="`sat_${index}`"
                    class="d-flex align-items-center justify-content-center make-cursor-pointer"
                    @mouseleave="getTitle({...row.sat, index, day: 'sat', time: row.time}, false)"
                    @mouseover="getTitle({...row.sat, index, day: 'sat', time: row.time, live: true}, true)">
                  <span class="mr-10">{{ calculateBusyCoefficient({...row.sat.last15Min, time: row.time}) }}</span>
                  <span class="badge badge-success badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                    Live
                  </span>
                  <span>&nbsp | {{ getLastWeekStats(row.sat, row.time) }}
                    <span class="badge badge-danger badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                      Prev Week
                    </span>
                  </span>
                </div>
                <span v-else :id="`sat_${index}`" class="make-cursor-pointer"
                      @mouseleave="getTitle({...row.sat, index, day: 'sat', time: row.time}, false)"
                      @mouseover="getTitle({...row.sat, index, day: 'sat', time: row.time}, true)">{{
                    row.sat && row.sat.hoursArray ? getVal(row.sat.hoursArray, row.time, row.sat.date) : 0
                  }}</span>
              </td>
              <td :style="getClass(row.sun, row.time, 'Sunday')"
                  :width="row.sun && row.sun.date === originalCurrentDate ? '18%' : ''" class="text-center fw-600"
                  style="position: relative" @click="openStaffDetails(row.sun, row.time)">
                <div
                    v-if="currentTime.split(':')[0] === row.time.split(':')[0] && row.sun && row.sun.date === originalCurrentDate"
                    :id="`sun_${index}`"
                    class="d-flex align-items-center justify-content-center make-cursor-pointer"
                    @mouseleave="getTitle({...row.sun, index, day: 'sun', time: row.time}, false)"
                    @mouseover="getTitle({...row.sun, index, day: 'sun', time: row.time, live: true}, true)">
                  <span class="mr-10">{{ calculateBusyCoefficient({...row.sun.last15Min, time: row.time}) }}</span>
                  <span class="badge badge-success badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                    Live
                  </span>
                  <span>&nbsp | {{ getLastWeekStats(row.sun, row.time) }}
                    <span class="badge badge-danger badge-pill pt-3 pb-2 pr-5 pl-5 mt-4">
                      Prev Week
                    </span>
                  </span>
                </div>
                <span v-else :id="`sun_${index}`" class="make-cursor-pointer"
                      @mouseleave="getTitle({...row.sun, index, day: 'sun', time: row.time}, false)"
                      @mouseover="getTitle({...row.sun, index, day: 'sun', time: row.time}, true)">{{
                    row.sun && row.sun.hoursArray ? getVal(row.sun.hoursArray, row.time, row.sun.date) : 0
                  }}</span>
              </td>
            </tr>
            </tbody>
          </table>

          <div class="legend-container">
            <div class="legend-bar"></div>
            <div class="legend-labels">
              <span>Not Busy</span>
              <span>Slightly Busy</span>
              <span>Mildly Busy</span>
              <span>Moderate</span>
              <span>Busy</span>
              <span>Very Busy</span>
              <span>Extremely Busy</span>
            </div>
          </div>
          <staff-detail-modal ref="staffDetailModal"/>
          <overall-staff-modal ref="overallStaffModal"/>
        </div>
      </div>
    </div>
    <div v-else>
      <staff-stats :modifiedShifts="modifiedShifts"></staff-stats>
    </div>
  </div>
</template>
<script>
import staffDetailModal from "@/components/Admin/AdminDashboard/modal/staffDetailModal.vue";
import overallStaffModal from "@/components/Admin/AdminDashboard/modal/overallPerStaffTicketStats.vue";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import {defineComponent} from "vue";
import {db} from "@/firebase/init";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import moment from "moment-timezone";
import Datepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import staffStats from "@/components/Admin/AdminDashboard/staffStats.vue";

export default defineComponent({
  components: {
    Datepicker, PerfectScrollbar, staffDetailModal, overallStaffModal, staffStats
  },
  mounted() {
    this.getCurrentWeekDates()
    this.getAdminShifts()
    this.getPredictedData();
    this.getTicketStats();
  },
  beforeDestroy() {
    if (this.listener) {
      this.listener()
    }
  },
  props: {
    dateTime: {
      type: String
    }
  },
  data() {
    return {
      showIndividualStats: false,
      secretEmails: ['sara@bigscoots.com', 'khan@bigscoots.com', 'scott@bigscoots.com', 'justin@bigscoots.com', 'james@bigscoots.com'],
      gradientColors: [
        {stop: 0.0, color: "#2ecc40"},  // Not Busy
        {stop: 0.16, color: "#a3e635"}, // Slightly Busy
        {stop: 0.32, color: "#eab308"}, // Mildly Busy
        {stop: 0.48, color: "#f97316"}, // Moderate
        {stop: 0.64, color: "#ef4444"}, // Busy
        {stop: 0.80, color: "#b91c1c"}, // Very Busy
        {stop: 1.0, color: "#7f1d1d"}   // Extremely Busy
      ],
      perDayAvg: [],
      greyStripedStyle: 'background-image: repeating-linear-gradient(-45deg,rgba(220, 220, 220, 0.6),rgba(220, 220, 220, 0.6) 12px,rgba(180, 180, 180, 0.6) 12px,rgba(180, 180, 180, 0.6) 24px);background-attachment: fixed;background-size: 100% 100%;',
      weekSelected: 'current',
      filterEnabled: false,
      currentTime: moment().tz('America/New_York').format('HH:mm'),
      currentDate: moment().tz('America/New_York').format('YYYY-MM-DD'),
      originalCurrentDate: moment().tz('America/New_York').format('YYYY-MM-DD'),
      listener: null,
      selectedTab: 'currentWeek',
      currentDay: new Date().getDay(),
      weekDates: [],
      weekDatesWithDays: [],
      filterWeeksDates: [],
      allShifts: [],
      ticketStats: [],
      monitorStats: [],
      last15Min: {},
      predictedData: [],
      availableStaff: [],
      availableStaffOfCurrentWeek: [],
      maxBusyFactor: 0,
      maxAvgPerDay: 0,
      estTime: [
        {time: "00:00"},
        {time: "01:00"},
        {time: "02:00"},
        {time: "03:00"},
        {time: "04:00"},
        {time: "05:00"},
        {time: "06:00"},
        {time: "07:00"},
        {time: "08:00"},
        {time: "09:00"},
        {time: "10:00"},
        {time: "11:00"},
        {time: "12:00"},
        {time: "13:00"},
        {time: "14:00"},
        {time: "15:00"},
        {time: "16:00"},
        {time: "17:00"},
        {time: "18:00"},
        {time: "19:00"},
        {time: "20:00"},
        {time: "21:00"},
        {time: "22:00"},
        {time: "23:00"},
      ],
      daysOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    }
  },
  computed: {
    modifiedShifts() {
      return this.allShifts.filter(el => el.department === 'support')
    },
    getMinDate() {
      return
    },
    wholeWeekData() {
      const array = []
      for (const row of this.makeTicketStats) {
        if (row.mon) {
          const obj = row.mon.hoursArray.find(el => el.time === row.time)
          if (!!obj && (row.mon.date === this.originalCurrentDate ? obj.time <= this.currentTime : true)) {
            array.push({date: row.mon.date, time: obj.time, busyFactor: this.calculateBusyCoefficient(obj)})
          }
        }
        if (row.tues) {
          const obj = row.tues.hoursArray.find(el => el.time === row.time)
          if (!!obj && (row.tues.date === this.originalCurrentDate ? obj.time <= this.currentTime : true)) {
            array.push({date: row.tues.date, time: obj.time, busyFactor: this.calculateBusyCoefficient(obj)})
          }
        }
        if (row.wed) {
          const obj = row.wed.hoursArray.find(el => el.time === row.time)
          if (!!obj && (row.wed.date === this.originalCurrentDate ? obj.time <= this.currentTime : true)) {
            array.push({date: row.wed.date, time: obj.time, busyFactor: this.calculateBusyCoefficient(obj)})
          }
        }
        if (row.thurs) {
          const obj = row.thurs.hoursArray.find(el => el.time === row.time)
          if (!!obj && (row.thurs.date === this.originalCurrentDate ? obj.time <= this.currentTime : true)) {
            array.push({date: row.thurs.date, time: obj.time, busyFactor: this.calculateBusyCoefficient(obj)})
          }
        }
        if (row.fri) {
          const obj = row.fri.hoursArray.find(el => el.time === row.time)
          if (!!obj && (row.fri.date === this.originalCurrentDate ? obj.time <= this.currentTime : true)) {
            array.push({date: row.fri.date, time: obj.time, busyFactor: this.calculateBusyCoefficient(obj)})
          }
        }
        if (row.sat) {
          const obj = row.sat.hoursArray.find(el => el.time === row.time)
          if (!!obj && (row.sat.date === this.originalCurrentDate ? obj.time <= this.currentTime : true)) {
            array.push({date: row.sat.date, time: obj.time, busyFactor: this.calculateBusyCoefficient(obj)})
          }
        }
        if (row.sun) {
          const obj = row.sun.hoursArray.find(el => el.time === row.time)
          if (!!obj && (row.sun.date === this.originalCurrentDate ? obj.time <= this.currentTime : true)) {
            array.push({date: row.sun.date, time: obj.time, busyFactor: this.calculateBusyCoefficient(obj)})
          }
        }
      }
      this.maxBusyFactor = Math.max(...array.map(item => this.weekDates.includes(item.date) ? (!isNaN(item.busyFactor) ? item.busyFactor : 0) : 0));
      this.perDayAvg = []
      for (let row of this.weekDates) {
        if (row > this.originalCurrentDate) {
          row = this.getPrevWeekDate(row)
        }
        const arr = array.filter(item => item.date === row);
        if (arr.length) {
          this.perDayAvg.push({
            date: row,
            avg: Number(((arr.reduce((sum, entry) => sum + entry.busyFactor, 0)) / arr.length).toFixed(2))
          })
        }
      }
      this.maxAvgPerDay = Math.max(...this.perDayAvg.map(item => item.avg).filter(avg => avg !== null));
      return array;
    },
    makeTicketStats() {
      const times = JSON.parse(JSON.stringify(this.estTime));
      const array = []
      times.map(el => {
        const mon = this.getWeekDate('Monday');
        const tues = this.getWeekDate('Tuesday');
        const wed = this.getWeekDate('Wednesday');
        const thurs = this.getWeekDate('Thursday');
        const fri = this.getWeekDate('Friday');
        const sat = this.getWeekDate('Saturday');
        const sun = this.getWeekDate('Sunday');
        el.mon = this.makeDataForDays(mon, el.time)
        el.tues = this.makeDataForDays(tues, el.time)
        el.wed = this.makeDataForDays(wed, el.time)
        el.thurs = this.makeDataForDays(thurs, el.time)
        el.fri = this.makeDataForDays(fri, el.time)
        el.sat = this.makeDataForDays(sat, el.time)
        el.sun = this.makeDataForDays(sun, el.time)
        array.push(el)
      })
      return array
    },
  },
  watch: {
    async maxBusyFactor(val) {
      if (this.weekDates.includes(this.originalCurrentDate)) {
        const ref = await db.collection('dashboardStats').where('date', '==', this.originalCurrentDate).where('type', '==', 'ticket').limit(1).get();
        if (ref.size) {
          await db.collection('dashboardStats').doc(ref.docs[0].id).update({maxBusyFactor: val || 0})
        }
      }
    },
    weekDates(val) {
      // for(const row of val) {
      //   const staffMembers = await this.getAvailableStaffOnSpecificDate(row)
      //   this.availableStaffOfCurrentWeek.push({date: row, staffMembers})
      // }
      // this.getCurrentWeekDates()
      // this.getTicketStats();
    },
    dateTime(val) {
      this.currentTime = moment().tz('America/New_York').format('HH:mm')
      this.originalCurrentDate = moment().tz('America/New_York').format('YYYY-MM-DD')
    },
  },
  methods: {
    openStaffTicketStats() {
      this.showIndividualStats = true
      // this.$refs.overallStaffModal.load(this.allShifts.filter(el => el.department === 'support'))
    },
    parseDate(date) {
      return moment(date).format('DD MMM YYYY')
    },
    resetFilter() {
      this.filterEnabled = false;
      this.currentDate = moment().tz('America/New_York').format('YYYY-MM-DD');
      this.weekDates = []
      this.getCurrentWeekDates()
      this.getTicketStats()
    },
    async onSelectDate(e) {
      this.currentDate = e.target.value
      this.weekDates = []
      this.filterEnabled = true;
      await this.getCurrentWeekDates()
      await this.getTicketStats()
      // for(const row of this.weekDates) {
      // const obj = this.ticketStats.find(el => el.date === row)
      // if(!obj) {
      //   const resp = await axios.post('https://n8n.bigscoots.dev/webhook/hostbill/tickets/stats/manual/day', {
      //     date: row
      //   }, {
      //     headers: {
      //       Authorization: 'Bearer LASisdf83ASD823asdfAKSdfu73asedf7aswe6f'
      //     }
      //   })
      //   console.log('resp', resp.data)
      // }
      // }
    },
    changeWeekDates(value) {
      this.weekDates = []
      if (value === 'prev') {
        this.weekSelected = value
        this.weekDates = this.weekDates.map(el => this.getPrevWeekDate(el))
        this.currentDate = this.getPrevWeekDate(this.currentDate)
        this.getCurrentWeekDates()
        this.getTicketStats()
      } else {
        this.weekSelected = value
        this.weekDates = this.weekDates.map(el => this.getNextWeekDate(el))
        this.currentDate = this.getNextWeekDate(this.currentDate)
        this.getCurrentWeekDates()
        this.getTicketStats()
      }
    },
    getAvg(row) {
      let avg = 0
      let prevWeekAvg = 0
      let twoWeeksAgoAvg = 0
      let predicted = false
      const data = this.ticketStats.find(el => el.date === row.date && el.date <= this.originalCurrentDate);
      console.log('data', '189', data)
      let sum = 0
      if (data) {
        const {hoursArray} = data;
        for (const [i, hour] of hoursArray.entries()) {
          if (Object.keys(hour).length === 1) {
            continue
          }
          sum += Number(this.calculateBusyCoefficient(hour))
          if (hour.prevData) {
            const oneWeekAgo = hour.prevData.find(el => el.previousWeek)
            const twoWeekAgo = hour.prevData.find(el => el.beforePreviousWeek)
            if (oneWeekAgo) {
              // console.log('443', oneWeekAgo, Number(this.calculateBusyCoefficient(oneWeekAgo)))
              prevWeekAvg += Number(this.calculateBusyCoefficient(oneWeekAgo))
            }
            if (twoWeekAgo) {
              twoWeeksAgoAvg += Number(this.calculateBusyCoefficient(twoWeekAgo))
            }
            console.log('474', prevWeekAvg)
          }
        }
      } else {
        const predictedData = this.getPredictedDataObj(row.date)
        if (predictedData) {
          const {hoursArray} = predictedData;
          for (const [i, hour] of hoursArray.entries()) {
            if (Object.keys(hour).length === 1) {
              continue
            }
            console.log('197', this.calculateBusyCoefficient(hour))
            sum += Number(this.calculateBusyCoefficient(hour))
            if (hour.prevData) {
              const oneWeekAgo = hour.prevData.find(el => el.previousWeek)
              const twoWeekAgo = hour.prevData.find(el => el.beforePreviousWeek)
              if (oneWeekAgo) {
                console.log('489', oneWeekAgo)
                prevWeekAvg += Number(this.calculateBusyCoefficient(oneWeekAgo))
              }
              if (twoWeekAgo) {
                twoWeeksAgoAvg += Number(this.calculateBusyCoefficient(twoWeekAgo))
              }
            }
          }
          predicted = true
        }
      }
      console.log('sum at 553', row.date, sum)
      if (row.date === this.originalCurrentDate) {
        avg = (sum / (1 + Number(this.currentTime.split(':')[0]))).toFixed(2)
      } else {
        avg = (sum / 24).toFixed(2)
      }
      if (row.date > this.originalCurrentDate) {
        // because now prev week has become current for coming dates in current week
        prevWeekAvg = (sum / 24).toFixed(2);
        twoWeeksAgoAvg = (prevWeekAvg / 24).toFixed(2)
      } else {
        prevWeekAvg = (prevWeekAvg / 24).toFixed(2);
        twoWeeksAgoAvg = (twoWeeksAgoAvg / 24).toFixed(2)
      }
      // if(!this.perDayAvg.find(el => el.date === row.date && avg > 0)) {
      //   this.perDayAvg.push({date: row.date, avg})
      // }
      console.log('prevweek', prevWeekAvg)
      return {avg, prevWeekAvg, twoWeeksAgoAvg, predicted}
    },
    getHighlightClass(row) {
      let className = ''

      // this.maxBusyFactor = Math.max(...array.map(item => this.weekDates.includes(item.date) ?( !isNaN(item.busyFactor) ? item.busyFactor : 0) : 0));
      const array = this.wholeWeekData.find(el => el.date <= this.originalCurrentDate ? el.date === row.date : this.getPrevWeekDate(row.date) === el.date);
      if (array) {

      }
      // const {avg, prevWeekAvg, twoWeeksAgoAvg, predicted} = this.getAvg(row)
      // const array = [avg, prevWeekAvg, twoWeeksAgoAvg].sort((a, b) => b-a);
      // if(avg === array[0]) {
      //   className += predicted ? 'no-coverage-striped' : ' no-coverage'
      // }else if(avg === array[1]) {
      //   className += predicted ? 'yellow-striped' : ' yellow'
      // }if(avg === array[2]) {
      //   className += predicted ? 'ultra-green-striped' :' ultra-green'
      // }
      // console.log('array at 231', array)
      return className
    },
    getHighlightClass2(row) {
      let className = ''
      const {avg, prevWeekAvg, twoWeeksAgoAvg, predicted} = this.getAvg(row)
      const array = [avg, prevWeekAvg, twoWeeksAgoAvg].sort((a, b) => b - a);
      if (avg === array[0]) {
        className += predicted ? 'no-coverage-striped' : ' no-coverage'
      } else if (avg === array[1]) {
        className += predicted ? 'yellow-striped' : ' yellow'
      }
      if (avg === array[2]) {
        className += predicted ? 'ultra-green-striped' : ' ultra-green'
      }
      console.log('array at 231', array)
      return className
    },
    makeDataForDays(date, time) {
      const obj = this.ticketStats.find(stats => stats.date === date);
      console.log('obj at 230', obj)
      if (obj) {
        const requiredHour = obj.hoursArray.find(el2 => el2.time === time);
        console.log('requiredHour', requiredHour)
        if (requiredHour && requiredHour.availableStaff && !requiredHour.availableCount) {
          requiredHour.availableCount = requiredHour.availableStaff.reduce((sum, item) => sum + Number(item.availability), 0).toFixed(2);
        }
        return obj
      } else {
        const predictedData = this.getPredictedDataObj(date)
        console.log('predictedData at 230', predictedData)
        if (predictedData) {
          const requiredPredictedHour = predictedData.hoursArray.find(el2 => el2.time === time);
          console.log('requiredPredictedHour', requiredPredictedHour)
          if (requiredPredictedHour && requiredPredictedHour.availableStaff && !requiredPredictedHour.availableCount) {
            requiredPredictedHour.availableCount = requiredPredictedHour.availableStaff.reduce((sum, item) => sum + Number(item.availability), 0).toFixed(2);
          }
          predictedData.predicted = true;
          return predictedData
        }
      }
    },
    getVal(array, time, date) {
      const obj = array.find(el => el.time === time);
      // console.log('getting value', obj)
      let busyFactor = 0
      if (!!obj && obj.total_responses && obj.total_tickets_handled && obj.availableCount) {
        busyFactor = this.calculateBusyCoefficient({...obj, time}, date) || 0
      } else {
        const predictedData = this.getPredictedDataObj(date)
        // console.log('predictedData at 230', predictedData)
        if (predictedData && !!predictedData) {
          const desiredObj = predictedData.hoursArray.find(el => el.time === time);
          if (!!desiredObj && desiredObj.total_responses && desiredObj.total_tickets_handled && desiredObj.availableCount) {
            busyFactor = this.calculateBusyCoefficient(desiredObj) || 0
          }
        }
      }
      return busyFactor
    },
    async getAvailableStaffOnSpecificDate(date) {
      const array = []
      const ref = await db.collection('attendance').where('date', '==', date).get()
      if (ref.size) {
        ref.forEach(el => {
          const data = el.data();
          console.log('data', data)
          array.push(data)
          // this.availableStaff.push(data);
        })
      }
      return array
    },
    async getData(data, time) {
      console.log('data received', data, time)
      if (!data) {
        return 0
      }
      let ratio = 0
      if (data && data.hoursArray && data.hoursArray.length) {
        const obj = data.hoursArray.find(el => el.time === time);
        console.log('objjjjj', obj)
        if (obj) {
          if (obj.total_tickets_handled && obj.total_responses) {
            data.availableStaff = data.staffMembers.map(el => {
              const {breaks} = el;
              if (breaks && breaks.length) {
                const {date} = data;
                // date format is 2025-03-14
                const targetStart = new Date(date.split('-')[0], date.split('-')[1] - 1, date.split('-')[2], time.split(':')[0], 0, 0).toISOString()
                const targetEnd = new Date(date.split('-')[0], date.split('-')[1] - 1, date.split('-')[2], time.split(':')[0], 59, 59).toISOString()
                const breakObj = breaks.find(el2 => {
                  const start = moment(el2.startTime).format('HH:mm')
                  const end = moment(el2.endTime).format('HH:mm')
                  console.log('el.email', el.email, start, end, time >= start,)
                  if (start >= time && start <= `${time.split(':')[0]}:59`) {
                    return true
                  }
                })
                console.log('break obj at 301', breakObj)
                if (breakObj) {
                  const start = new Date(breakObj.startTime).toISOString();
                  const end = new Date(breakObj.endTime).toISOString();
                  // const mDate = new Date(data.date);
                  const actualStart = new Date(start) > new Date(targetStart) ? start : targetStart;
                  const actualEnd = new Date(end) < new Date(targetEnd) ? end : targetEnd;
                  console.log('actualStart', actualStart, actualEnd,)
                  // Calculate minutes in target hour
                  const diffInMs = new Date(actualEnd) - new Date(actualStart)
                  console.log('in min', diffInMs)
                  const diff = Math.abs(diffInMs) / (60 * 1000)
                  console.log('diffInMs', diff);
                  if (diff > 60) {
                    el.availability = 0
                  } else if (diff < 60) {
                    el.availability = (1 - (diff / 60)).toFixed(2)
                  }
                } else {
                  el.availability = 1
                }
              } else {
                el.availability = 1
              }
              return el
            })
            console.log('availibity of staff', availableStaff)
            data.availableCount = availableStaff.reduce((sum, item) => sum + Number(item.availability), 0);
            console.log('availableCount', data.availableCount)
            ratio = (obj.total_responses / obj.total_tickets_handled) / data.availableCount
          }
        }
      }
      console.log('final ratio', ratio)
      return data
    },
    async getTicketStats() {
      this.ticketStats = []
      this.monitorStats = []
      this.listener = await db.collection('dashboardStats').where('date', 'in', this.weekDates).onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(changeDoc => {
          if (changeDoc.type === 'added') {
            console.log('addin new', 418)
            const {type} = changeDoc.doc.data()
            if (type === 'ticket') {
              this.ticketStats.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
              if (changeDoc.doc.data().date === this.originalCurrentDate) {
                this.last15Min = changeDoc.doc.data().last15Min;
                this.$store.dispatch('calculateBusyCoefficient', this.last15Min)
              }
            } else if (type === 'monitor') {
              this.monitorStats.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
            }
          }
          if (changeDoc.type === 'modified') {
            console.log('modified')
            const data = {id: changeDoc.doc.id, ...changeDoc.doc.data()}
            if (data.type === 'ticket') {
              this.ticketStats = this.ticketStats.filter(el => el.id !== changeDoc.doc.id)
              this.ticketStats.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
              if (data.date === this.originalCurrentDate) {
                this.last15Min = data.last15Min;
                this.$store.dispatch('calculateBusyCoefficient', this.last15Min)
              }
            } else if (data.type === 'monitor') {
              this.monitorStats = this.monitorStats.filter(el => el.id !== changeDoc.doc.id)
              this.monitorStats.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
            }
          }
          if (changeDoc.type === 'removed') {
            this.ticketStats = this.ticketStats.filter(el => el.id !== changeDoc.doc.id)
            this.monitorStats = this.monitorStats.filter(el => el.id !== changeDoc.doc.id)
          }
        });
      });
    },
    async getPredictedData() {
      const index = this.weekDates.findIndex(el => el === this.currentDate)
      let array = this.weekDates.slice(index)
      console.log('prev week array', array)
      array = array.map(el => {
        const prevWeekDate = this.getPrevWeekDate(el)
        return prevWeekDate
      })
      console.log('prev week array', array)
      const ref = await db.collection('dashboardStats').where('type', '==', 'ticket').where('date', 'in', array).get();
      if (ref.size) {
        ref.forEach(el => {
          this.predictedData.push({id: el.id, ...el.data()})
        })
      }
    },
    getWeekDate(day) {
      // console.log('new Date(el).getDay()', moment('2025-03-17').tz('America/New_York').format('dddd'))
      const obj = this.weekDatesWithDays.find(el => el.day === day)
      return obj ? obj.date : ''
    },
    groupDateRanges(dates) {
      // Convert string dates to Date objects and sort them
      let dateObjects = dates.map(date => new Date(date)).sort((a, b) => a - b);

      let result = [];
      let start = dateObjects[0];
      let end = dateObjects[0];

      for (let i = 1; i < dateObjects.length; i++) {
        let currentDate = dateObjects[i];
        let previousDate = new Date(end);
        previousDate.setDate(previousDate.getDate() + 1); // Get next consecutive date

        if (currentDate.getTime() === previousDate.getTime()) {
          // If consecutive, update the range end
          end = currentDate;
        } else {
          // Push the formatted range and reset start & end
          result.push(this.formatRange(start, end));
          start = currentDate;
          end = currentDate;
        }
      }

      // Push the last processed range or single date
      result.push(this.formatRange(start, end));

      return result.join(', ');
    },

    // Helper function to format date ranges
    formatRange(start, end) {
      const options = {month: "short", day: "2-digit", year: "numeric"};
      const startStr = start.toLocaleDateString("en-US", options);
      const endStr = end.toLocaleDateString("en-US", options);
      return startStr === endStr ? startStr.split(',')[0] : `${startStr.split(',')[0]} - ${endStr.split(',')[0]}`;
    },
    // get current week and last two weeks
    getCurrentWeekDates() {
      const estNow = moment(this.currentDate).tz("America/New_York"); // Current time in EST
      const startOfCurrentWeek = estNow.clone().startOf('week').add(1, 'day'); // Start from Monday

      const allDates = [];

      for (let w = 0; w < 1; w++) { // Loop for 3 weeks (current + last 2)
        const startOfWeek = startOfCurrentWeek.clone().subtract(w * 7, 'days');

        for (let i = 0; i < 7; i++) {
          const dateObj = startOfWeek.clone().add(i, 'days');
          allDates.push({
            day: dateObj.format('dddd'),  // Full day name
            date: dateObj.format('YYYY-MM-DD') // Date in YYYY-MM-DD format
          });
          this.weekDates.push(dateObj.format('YYYY-MM-DD'))
        }
      }
      this.weekDatesWithDays = allDates.sort((a, b) => moment(b.date).tz('America/New_York').format('YYY-MM-DD') - moment(a.date).tz('America/New_York').format('YYYY-MM-DD'))
    },
    async getAdminShifts() {
      const ref = await db.collection("admin-shifts").get();
      if (ref.size) {
        ref.forEach(el => {
          this.allShifts.push({id: el.id, ...el.data()})
        })
      }
    },
    getOnLeave(array, day) {
      return array.filter(el => el.shifts[day].onLeave).length
    },
    getLastWeekStats(array, time) {
      const obj = array.hoursArray.find(el => el.time === time);
      console.log('obj for 588', obj)
      if (obj && obj.prevData) {
        const prevWeek = obj.prevData.find(el => el.previousWeek);
        if (prevWeek) {
          return this.calculateBusyCoefficient(prevWeek)
        }
      }
      return 0
    },
    openStaffDetails(data, time) {
      if (this.secretEmails.includes(this.user.email)) {
        const isLive = this.currentTime.split(':')[0] === time.split(':')[0] && data.date === this.originalCurrentDate
        const currentMonitor = this.monitorStats.find(el => el.date === data.date);
        this.$refs.staffDetailModal.load({
          ...data,
          time,
          isLive,
          currentMonitorObj: currentMonitor ? currentMonitor.hoursArray.find(el => el.time === time) : {}
        })
      }
    },
    calculateBusyCoefficient(obj, date) {
      // console.log('443', obj)
      let availableCount = obj.availableCount
      if (!obj.availableCount || obj.availableCount == 0) {
        availableCount = 1
      }
      let monitors = 0
      if (obj.monitors) {
        monitors = obj.monitors
      } else {
        if (date) {
          monitors = this.getMonitorCount(date, obj.time)
        }
      }
      // console.log('moonitors', monitors, obj.total_tickets_handled+obj.total_responses)
      return Number(((obj.total_tickets_handled + obj.total_responses + monitors) / Number(availableCount)).toFixed(2))
    },
    getMonitorCount(date, time) {
      let monitors = 0
      const objMonitor = this.monitorStats.find(el => el.date === date);
      // console.log('monitor obj', objMonitor)
      if (objMonitor) {
        const required = objMonitor.hoursArray.find(el => el.time === time)
        if (required && required.staff) {
          console.log('required staff', required)
          monitors = required.staff.reduce((sum, record) => sum + record.count, 0);
        }
      }
      return monitors
    },
    getTitle(array, flag) {
      if (!flag || !array || !array.hoursArray) {
        return true
      }
      let title = ''
      if (array.live) {
        title += `<div class="p-2"><h6 class="text-center">Last 15 Min Stats</h6>`;
        if (!array.last15Min.availableStaff) return true
        title += `Total Tickets Handled: ${array.last15Min.total_tickets_handled}<br>`
        title += `Total Responses: ${array.last15Min.total_responses}<br>    `
        title += `Total Available Staff: ${array.last15Min.availableCount.toFixed(2)}/${array.last15Min.availableStaff.length}.00<br>`
        title += `Total Monitors: ${this.getMonitorCount(array.date, array.time)}<br>`
        title += `Busy Factor: ${this.calculateBusyCoefficient(array.last15Min)}<br>`
        title += '</div>'
      } else {
        if (array.hoursArray) {
          let obj = array.hoursArray.find(el => el.time === array.time);
          if (Object.keys(obj).length === 1) {
            const predictedData = this.getPredictedDataObj(array.date)
            if (predictedData) {
              obj = predictedData.hoursArray.find(el => el.time === array.time)
              obj.predicted = true
            }
          }
          if (obj) {
            if (array.predicted || obj.predicted) {
              title = `<div class="text-danger text-center fw-600 mt-10">Predicted</div>`
            }
            title += `<div class="p-2"><h6 class="text-center">This Week</h6>`;
            if (!obj.availableCount || !obj.availableStaff) return true
            title += `Total Tickets Handled: ${obj.total_tickets_handled}<br>`
            title += `Total Responses: ${obj.total_responses}<br>    `
            title += `Total Monitors: ${this.getMonitorCount(array.date, array.time)}<br>`
            title += `Total Available Staff: ${obj.availableCount.toFixed(2)}/${obj.availableStaff.length}.00<br>`
            title += `Busy Factor: ${this.calculateBusyCoefficient({...obj, time: array.time}, array.date)}<br><br>`
            if (obj.prevData) {
              const oneWeekAgo = obj.prevData.find(el => el.previousWeek)
              const twoWeekAgo = obj.prevData.find(el => el.beforePreviousWeek)
              if (oneWeekAgo) {
                title += `<h6 class="text-center">One Week Ago</h6>`;
                title += `Total Tickets Handled: ${oneWeekAgo.total_tickets_handled}<br>`
                title += `Total Responses: ${oneWeekAgo.total_responses}<br>    `
                title += `Total Available Staff: ${oneWeekAgo.availableCount.toFixed(2)}/${oneWeekAgo.totalStaff}.00<br>`
                title += `Total Monitors: ${oneWeekAgo.monitors || 0}<br>`
                title += `Busy Factor: ${this.calculateBusyCoefficient(oneWeekAgo)}<br><br>`
              }
              if (twoWeekAgo) {
                title += `<h6 class="text-center">Two Weeks Ago</h6>`;
                title += `Total Tickets Handled: ${twoWeekAgo.total_tickets_handled}<br>`
                title += `Total Responses: ${twoWeekAgo.total_responses}<br>    `
                title += `Total Available Staff: ${twoWeekAgo.availableCount.toFixed(2)}/${twoWeekAgo.totalStaff}.00<br>`
                title += `Total Monitors: ${twoWeekAgo.monitors || 0}<br>`
                title += `Busy Factor: ${this.calculateBusyCoefficient(twoWeekAgo)}<br>`

              }

            }
            title += `</div>`
          }
        }
      }
      tippy(`#${array.day}_${array.index}`, {
        content: flag ? title : '',
        allowHTML: true,
        theme: 'dark', // Customize the theme in your CSS if needed
        placement: 'top'
      });
    },
    renderDatatable() {
      // console.log('rendering')
      if ($.fn.DataTable.isDataTable('#datatble')) {
        $(`#datatble`).DataTable().destroy();
      }
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
      setTimeout(function () {
        $(`#datatble`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo": false,
          "ordering": false,
        });
      }, 0)
    },
    getPrevWeekDate(date) {
      const modifiedDate = moment.tz(date, "YYYY-MM-DD", "America/New_York");
      const prevWeekDate = (modifiedDate.clone().subtract(7, 'days')).format('YYYY-MM-DD');
      return prevWeekDate
    },
    getNextWeekDate(date) {
      const modifiedDate = moment.tz(date, "YYYY-MM-DD", "America/New_York");
      const prevWeekDate = (modifiedDate.clone().add(7, 'days')).format('YYYY-MM-DD');
      return prevWeekDate
    },
    getPredictedDataObj(date) {
      const prevDate = this.getPrevWeekDate(date);
      return this.predictedData.find(el => el.date === prevDate);
    },
    getInterpolatedColor(value, max) {
      // console.log('at 861', value, max)
      const ratio = Math.max(0, Math.min(value / max, 1));
      let start, end;

      for (let i = 0; i < this.gradientColors.length - 1; i++) {
        if (ratio >= this.gradientColors[i].stop && ratio <= this.gradientColors[i + 1].stop) {
          start = this.gradientColors[i];
          end = this.gradientColors[i + 1];
          break;
        }
      }
      // console.log('end at 871', end, start)
      if (!end || !start) return ''
      const range = end.stop - start.stop;
      const relativeRatio = (ratio - start.stop) / range;

      return this.interpolateColor(start.color, end.color, relativeRatio);
    },
    interpolateColor(color1, color2, factor) {
      const c1 = this.hexToRgb(color1);
      const c2 = this.hexToRgb(color2);
      const r = Math.round(c1.r + (c2.r - c1.r) * factor);
      const g = Math.round(c1.g + (c2.g - c1.g) * factor);
      const b = Math.round(c1.b + (c2.b - c1.b) * factor);
      return `rgb(${r},${g},${b})`;
    },
    hexToRgb(hex) {
      const parsed = hex.replace('#', '');
      return {
        r: parseInt(parsed.substring(0, 2), 16),
        g: parseInt(parsed.substring(2, 4), 16),
        b: parseInt(parsed.substring(4, 6), 16),
      };
    },
    getClass(array, time, day) {
      // console.log('required class', array)
      let className = '';
      // to highlight the current day column
      const date = moment().tz('America/New_York').format('YYYY-MM-DD');
      const currentTime = moment().tz('America/New_York').format('HH');
      const rowDate = this.weekDatesWithDays.find(el => el.day === day)
      if (rowDate && rowDate.date === date) {
        className += 'border-left border-right'
        if (time === '00:00') {
          className += ' border-top'
        } else if (time === '23:00') {
          className += ' border-bottom'
        }
        if (time.split(':')[0] === currentTime) {
          className += ' highlight-time'
        }
      }
      if (!array || !array.hoursArray) {
        className += ' muted-red'
        return className
      }
      let obj = array.hoursArray.find(el => el.time === time);
      // console.log('obj at 476', obj)
      // this means only time exist and no data found
      if (obj && Object.keys(obj).length === 1) {
        const predictedObj = this.getPredictedDataObj(array.date)
        if (predictedObj) {
          obj = predictedObj.hoursArray.find(el => el.time === time)
        }
      }
      let currentWeek = 0;
      if (obj) {
        currentWeek = this.calculateBusyCoefficient(obj)
      }
      if (isNaN(currentWeek)) {
        currentWeek = 0
      }
      const color = this.getInterpolatedColor(currentWeek, this.maxBusyFactor)
      if (array.date === this.originalCurrentDate && time.split(':')[0] === this.currentTime.split(':')[0]) {
        return 'background: black; color: white'
      }
      if (array.date <= this.originalCurrentDate && this.weekDates.includes(array.date) && (array.date === this.originalCurrentDate ? time <= this.currentTime : true)) {
        return `background: ${color}`
      } else {
        return this.greyStripedStyle
      }
    }
  }
})
</script>

<style scoped>
.muted-red {
  background: #e2dfdfe0;
}

.yellow {
  background: #FEF2C7 !important;
}

.no-coverage {
  background: #FDE2E1;
}

.light-green {
  background: #D1FAE4 !important;
}

.ultra-green {
  background: #33ff002e;
}

.yellow-striped {
  background-image: repeating-linear-gradient(
      -45deg,
      rgba(255, 247, 209, 0.6),
      rgba(255, 247, 209, 0.6) 12px,
      rgba(249, 226, 156, 0.6) 12px,
      rgba(249, 226, 156, 0.6) 24px
  );
  background-attachment: fixed;
  background-size: 100% 100%;
}

.no-coverage-striped {
  background: repeating-linear-gradient(
      -45deg, /* 45° for right diagonal stripes */ rgb(253, 226, 225, 0.6), /* Light Pink color */ rgb(253, 226, 225, 0.6) 12px, /* Stripe width */ rgb(248, 198, 196, 0.6) 12px, /* Darker shade of the same color */ rgb(248, 198, 196, 0.6) 24px /* Stripe length */
  );
  background-attachment: fixed;
  background-size: 100% 100%;
}

.ultra-green-striped {
  background: repeating-linear-gradient(
      -45deg, /* 45° for right diagonal stripes */ rgb(226, 255, 220, 0.6), /* Light Green color */ rgb(226, 255, 220, 0.6) 12px, /* Stripe width */ rgba(179, 230, 179, 0.6) 12px, /* Darker shade of the same color */ rgba(179, 230, 179, 0.6) 24px /* Stripe length */
  );;
  background-attachment: fixed;
  background-size: 100% 100%;
}

.circle {
  padding: 10px 15px 10px 15px;
  margin: 10px;
  margin-top: 15px;
  margin-bottom: 15px;
  border-radius: 50%;
}

.highlight-time {
  border: 2px solid darkgrey !important;
}

.border-right {
  border-right: 2px solid darkgrey !important;
}

.border-left {
  border-left: 2px solid darkgrey !important;
}

.border-top {
  border-top: 2px solid darkgrey !important;
}

.border-bottom {
  border-bottom: 2px solid darkgrey !important;
}

.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.header {
  border-top: 2px solid darkgrey;
  border-left: 2px solid darkgrey;
  border-right: 2px solid darkgrey;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}

.team-card {
  background: #F9F9F9;
  border: 0.3px solid #DDDDDD
}

@keyframes moveStripes {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 100px 100px;
  }
}

.yellow-animated-bg {
  /* Diagonal Stripes */
  background-image: repeating-linear-gradient(
      -45deg,
      rgba(255, 247, 209, 0.6),
      rgba(255, 247, 209, 0.6) 12px,
      rgba(249, 226, 156, 0.6) 12px,
      rgba(249, 226, 156, 0.6) 24px
  );
  background-attachment: fixed;
  background-size: 100% 100%;
  border-top: 2px solid darkgrey;
  border-left: 2px solid darkgrey;
  border-right: 2px solid darkgrey;
  animation: moveStripes 2s linear infinite;
}

.red-animated-bg {
  /* Diagonal Stripes */
  background: repeating-linear-gradient(
      -45deg, /* 45° for right diagonal stripes */ rgb(253, 226, 225, 0.6), /* Light Pink color */ rgb(253, 226, 225, 0.6) 12px, /* Stripe width */ rgb(248, 198, 196, 0.6) 12px, /* Darker shade of the same color */ rgb(248, 198, 196, 0.6) 24px /* Stripe length */
  );
  background-attachment: fixed;
  background-size: 100% 100%;
  border-top: 2px solid darkgrey;
  border-left: 2px solid darkgrey;
  border-right: 2px solid darkgrey;
  animation: moveStripes 2s linear infinite;
}

.green-animated-bg {
  /* Diagonal Stripes */
  background: repeating-linear-gradient(
      -45deg, /* 45° for right diagonal stripes */ rgb(226, 255, 220, 0.6), /* Light Green color */ rgb(226, 255, 220, 0.6) 12px, /* Stripe width */ rgba(179, 230, 179, 0.6) 12px, /* Darker shade of the same color */ rgba(179, 230, 179, 0.6) 24px /* Stripe length */
  );;
  background-attachment: fixed;
  background-size: 100% 100%;
  border-top: 2px solid darkgrey;
  border-left: 2px solid darkgrey;
  border-right: 2px solid darkgrey;
  animation: moveStripes 2s linear infinite;
}

th {
  border: 2px solid darkgrey !important;
}

* {
  box-sizing: border-box;

}

.legend-container {
  width: 80%;
  margin: 2rem auto 0 auto;
  text-align: center;
}

.legend-bar {
  height: 20px;
  background: linear-gradient(
      to right,
      #2ecc40, /* Not Busy - Green */ #a3e635, /* Slightly Busy - Lime */ #eab308, /* Mildly Busy - Yellow */ #f97316, /* Moderately Busy - Orange */ #ef4444, /* Busy - Red */ #b91c1c, /* Very Busy - Deep Red */ #7f1d1d /* Extremely Busy - Dark Red */
  );
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-top: 8px;
}

.legend-labels {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-top: 4px;
  padding: 0 2px;
}


</style>